import React from 'react';
import type { SectionHeaderProps } from './types/UIProps';

export type { SectionHeaderProps };

export function SectionHeader({
  title,
  subtitle,
  actions,
  className = '',
}: SectionHeaderProps): React.ReactElement {
  return (
    <div className={`flex flex-wrap items-start justify-between gap-3 ${className}`.trim()}>
      <div className="min-w-0">
        <h2 className="text-sm font-semibold text-gray-900 dark:text-slate-100">{title}</h2>
        {subtitle ? (
          <p className="mt-0.5 text-xs text-gray-500 dark:text-slate-400">{subtitle}</p>
        ) : null}
      </div>
      {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
